export default __webpack_public_path__ + "static/media/ticino_grisons.3db8871b.xlsx";